const VoucherModel = {
  NORMAL: 1,
  PRODUCT: 2
}
export default VoucherModel
